
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment, useEffect, useState } from "react";
import Select from "react-select";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Accordion from '../../accordion'


// ../../../../images/candidate/upload.png
//  download fill

import Upload from "../../../../images/candidate/download.svg";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Button,
    Form,
    Input,
} from "reactstrap";

import pdf from "../../images/document.svg";
import { useProfilecontext } from "../Editprofileprovider";
import request from "../../../../api/api";
import { initailState } from "../utils/profileReducer";
import { DateInput, NextButton, NumberInput, TextAreaInput, TextInput, YESORNO } from "./UserInputs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
import { isValidDate, VaccinationList , createFormData , scroll_to_top , convertToISOString } from "../../../common/utils";
import moment from "moment";



const customSize = {
  control: (base) => ({
      ...base,
      minHeight:"50px",
      fontSize:"14px"
  }),
  menu: (base) => ({
      ...base,
      marginLeft: "0px", marginTop: "0px", fontSize: "14px", zIndex:9
  }),
  placeholder: (base) => ({
    ...base,
    fontSize:"14px"
  }),
  input: (defaultStyles) => {
      return {
          ...defaultStyles,
          padding: "0 22px",
          color: "#343434",
          outline: "none",
          fontSize:"14px"
      }
  },
  
}


const addfileToServer = async (file = {}) =>{
    try {
    const res = await request({ url: "/candidate/form/addFilestoLocalDB", method: "POST", data:file,})
        return res.file_path ? res.file_path :''
    } catch (error) {
        return error;
    }
}



const accordion_id = {
    medical_history_1:0,
    medical_history_2:1,
    tuberculosis:2,
    medical_history_report:3,
    covidVaccination:4,
    immunisation_history:5,
    gpdetails:6,
};



export default function HealthQuestionTab() {

    const [ state , dispatch ] = useProfilecontext();

    const [active_accordion , setActiveAccordion ] = useState(accordion_id['medical_history_1'])

    const toggleAccordion = (id = '') => {
        setActiveAccordion((prev)=>(accordion_id[id]) || prev)

    }

        
    const toggleTab = (tab = '', tabId = '') => {
        setActiveAccordion(0)
        dispatch({ type: "TOGGLE_TAB", payload: { tab, tabId } })
        scroll_to_top()
    }

    const handleSetToast = ({id = '' , message = '' , type = ''})=>{
        dispatch({type:"SET_TOAST" , payload:{ id, message , type}})
    }



    
    return (
        <div className="health-ques">
            <Accordion open={active_accordion} toggleAccordion={setActiveAccordion}>
                
                <Accordion.Item>
                    <Accordion.Header> Medical History 1 </Accordion.Header>
                    <Accordion.Body>
                        <MedicalHistoryFirst {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item>
                    <Accordion.Header> Medical History 2 </Accordion.Header>
                    <Accordion.Body>
                        <MedicalHistorySecond {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item>
                    <Accordion.Header> Tuberculosis </Accordion.Header>
                    <Accordion.Body>
                        <Tuberculosis {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item>
                    <Accordion.Header>  Medical History  </Accordion.Header>
                    <Accordion.Body>
                        <MedicalHistoryReport {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item>
                    <Accordion.Header>COVID Vaccination History </Accordion.Header>
                    <Accordion.Body>
                        <CovidVaccination {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item>
                    <Accordion.Header> Immunisation History </Accordion.Header>
                    <Accordion.Body>
                        <ImmunisationHistory {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item>
                    <Accordion.Header>GP’s Details </Accordion.Header>
                    <Accordion.Body>
                        <GPDetails {...state} toggleAccordion={toggleAccordion} handleSetToast={handleSetToast} toggleTab={toggleTab} />
                    </Accordion.Body>
                </Accordion.Item>

            </Accordion>
            <hr style={{ width: "100%" }} />

            <div className="position-relative col-12 col-md-12">
                <div className="mt-0 text-center three_button" id="s-c-buttons">
                    <Button onClick={()=>toggleTab("menu" ,"3")}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Previous</Button>
                    {/* <Button className="btn-save">Save</Button> */}
                    {/* <Button>Continue</Button> */}
                </div>
            </div>


        </div>
    )
}






// for MedicalHistoryFirst
const ProvideDetails = React.forwardRef(
    /**
     * @param {React.DOMAttributes<HTMLTextAreaElement>} props 
     */
    (props = {} , ref) => {
    return <div className="position-relative col-12 col-md-4 mt-3">
        <div className="form-group">
            <textarea {...props} ref={ref} placeholder="Please provide details" className="form-control"></textarea>
            <label>{props.label || "Please provide details"}</label>
        </div>
    </div>
})


const medicalhistoryfirstSchema = yup.object({

})
const MedicalHistoryFirst = (props = initailState) =>{

    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , control , watch , setValue , getValues , trigger , formState , handleSubmit} = useForm({
        values:{
            sufferedlongtermillness:props.sufferedlongtermillness || "",
            //  if yes sufferedlongtermillness
            sufferedlongtermillness_notes:props.sufferedlongtermillness_notes || "",

            leaveforneckinjury:props.leaveforneckinjury || "",
            // if yes leaveforneckinjury
            leaveforneckinjury_notes:props.leaveforneckinjury_notes || "",

            neckinjuries:props.neckinjuries || "",
            // if yes neckinjuries
            neckinjuries_notes:props.neckinjuries_notes || "",
            
            sixweeksillness:props.sixweeksillness || "",
            // if yes sixweeksillness
            sixweeksillness_notes:props.sixweeksillness_notes || "",
            
            communicabledisease:props.communicabledisease || "",
            // if yes communicabledisease
            communicabledisease_notes:props.communicabledisease_notes || "",

            medicalattention:props.medicalattention || "",
            // if yes medicalattention
            healthdeclarationdetails:props.healthdeclarationdetails || "",

            absentfromwork:props.absentfromwork || "",
            
        },
        // resolver:yupResolver(medicalhistoryfirstSchema)
    }),
    { errors } = formState;


    

    const onFormSubmit = (data = {}) =>{
        const reference1 = createFormData({...data , setctionId:"medical_history_1"});
        if(updateForm){
            updateForm(reference1).then((res)=>{
                handleSetToast && handleSetToast({id:"medical_history_1" , message:"Saved!" , type:'success'})
                toggleAccordion("medical_history_2")
            })
        }

    };

    return <Form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="d-flex flex-wrap check_box_sec mt-0">

            <YESORNO label="Do you or have ever suffered from long term illness?" name="sufferedlongtermillness" register={register} />
            {
                watch("sufferedlongtermillness") === "yes" &&
                <ProvideDetails {...register("sufferedlongtermillness_notes")} />
            }

            <YESORNO label="Have you ever required sick leave for a back or neck injury?" name="leaveforneckinjury" register={register} />
            {
                watch("leaveforneckinjury") === "yes" &&
                <ProvideDetails {...register("leaveforneckinjury_notes")} />
            }

            <YESORNO label="Do you suffer with any back or neck injuries?" name="neckinjuries" register={register} />
            {
                watch("neckinjuries") === "yes" &&
                <ProvideDetails {...register("neckinjuries_notes")} />
            }

            <YESORNO label="Have you been in contact with anyone who is suffering from a contagious illness within the last six weeks?" name="sixweeksillness" register={register} />
            {
                watch("sixweeksillness") === "yes" &&
                <ProvideDetails {...register("sixweeksillness_notes")} />
            }

            <YESORNO label="Do you suffer with a communicable disease?" name="communicabledisease" register={register} />
            {
                watch("communicabledisease") === "yes" &&
                <ProvideDetails {...register("communicabledisease_notes")} />
            }

            <YESORNO label="Are you currently receiving active medical attention?" name="medicalattention" register={register} />
            {
                watch("medicalattention") === "yes" &&
                <ProvideDetails {...register("healthdeclarationdetails")} />
            }
            {
            watch(["sufferedlongtermillness" , "leaveforneckinjury" , "neckinjuries" ,"sixweeksillness" , "communicabledisease" , "medicalattention"]).includes("yes") && 

            <NumberInput 
                label="How many days have you been absent from work due to illness in the last 12 months?"
                placeholder="How many days have you been absent from work due to illness in the last 12 months?"
                {...register("absentfromwork" , { min:{ value:0 , message:"Required" , }  },)}
                parentClassName="col-12 col-md-10 mt-3"
                error={errors.absentfromwork && errors.absentfromwork.message }
            />
            // <div className="position-relative col-12 col-md-10 mt-3">
            //     <div className="form-group">
            //         <Input type="number" placeholder="How many days have you been absent from work due to illness in the last 12 months?" {...absentfromworkRef} innerRef={absentfromworkRef.ref}/>
            //         <label>How many days have you been absent from work due to illness in the last 12 months?</label>
            //     </div>
            // </div>
            }

        </div>
        <NextButton />
    </Form>
}






const ProvideDetailsMed2 = React.forwardRef(
    /**
     * @param {React.DOMAttributes<HTMLTextAreaElement>} props 
     */
    (props = {}, ref) => {
        return <div className="position-relative col-12 col-md-6">
            <div className="form-group">
                <textarea {...props} ref={ref} placeholder="Please provide details" className="form-control"></textarea>
                <label>Please provide details</label>
            </div>
        </div>
    })

const MedicalHistorySecond = (props = initailState) => {
    
    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , control , watch , setValue , getValues , trigger , formState , handleSubmit} = useForm({
        values:{
            // Medical History 2
            medicalillness:props.medicalillness || "",
            // if yes medicalillness
            medicalillness_notes:props.medicalillness_notes || "",
            
            medicalillnesscaused:props.medicalillnesscaused || "",
            // if yes medicalillnesscaused
            medicalillnesscaused_notes:props.medicalillnesscaused_notes || "",
            
            treatment:props.treatment || "",
            // if yes treatment
            treatment_notes:props.treatment_notes || "",
            
            needanyadjustments:props.needanyadjustments || "",
            // if yes needanyadjustments
            needanyadjustmentsnotes:props.needanyadjustmentsnotes || ""
        },
        // resolver:yupResolver(medicalhistoryfirstSchema)
    }),
    { errors } = formState;


    

    const onFormSubmit = (data = {}) =>{
        const medical_history_2 = createFormData({...data , setctionId:"medical_history_2"});
        if(updateForm){
            updateForm(medical_history_2).then((res)=>{
                toggleAccordion("tuberculosis")
                handleSetToast && handleSetToast({id:"medical_history_2" , message:"Saved!" , type:'success'})
            })
        }

    };


    return (
        <Form onSubmit={handleSubmit(onFormSubmit)}>
            <div className="d-flex flex-wrap check_box_sec mt-0">
            
                <YESORNO parentClassName="col-md-6 off_yes" label="Do you have any illness/impairment/disability (physical or psychological) which may affect your work?" register={register} name='medicalillness' />
                {
                    watch("medicalillness") === 'yes' && 
                    <ProvideDetailsMed2 {...register("medicalillness_notes")} />
                }
            
                <YESORNO parentClassName="col-md-6 off_yes" label="Have you ever had any illness/impairment/disability which may have been caused or made worse by your work?" register={register} name='medicalillnesscaused' />
                {
                    watch("medicalillnesscaused") === 'yes' && 
                    <ProvideDetailsMed2 {...register("medicalillnesscaused_notes")} />
                }
            
                <YESORNO parentClassName="col-md-6 off_yes" label="Are you having, or waiting for treatment (including medication) or investigations at present? If your answer is yes, please provide further details of the condition, treatment and dates?" register={register} name='treatment' />
                {
                    watch("treatment") === 'yes' && 
                    <ProvideDetailsMed2 {...register("treatment_notes")} />
                }
            
                <YESORNO parentClassName="col-md-6 off_yes" label="Do you think you may need any adjustments or assistance to help you to do the job?" register={register} name='needanyadjustments' />
                {
                    watch("needanyadjustments") === 'yes' && 
                    <ProvideDetailsMed2 {...register("needanyadjustmentsnotes")} />
                }
            </div>
            <NextButton />
        </Form>
    )
}





const Tuberculosis = (props = initailState) => {

    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , control , watch , setValue , getValues , trigger , formState , handleSubmit} = useForm({
        values:{
            livedUK:props.livedUK || "",
            // if no livedUK
            livedUKnotes:props.livedUKnotes || "",
                
            BCGvaccination:props.BCGvaccination || "",
            cough:props.cough || "",
            weightloss:props.weightloss || "",
            fever:props.fever || "",
            TB:props.TB || "",
        },
        // resolver:yupResolver(medicalhistoryfirstSchema)
    }),
    { errors } = formState;


    

    const onFormSubmit = (data = {}) =>{
        const tuberculosis = createFormData({...data , setctionId:"tuberculosis"});
        if(updateForm){
            updateForm(tuberculosis).then((res)=>{
                toggleAccordion("medical_history_report")
                handleSetToast && handleSetToast({id:"medical_history_2" , message:"Saved!" , type:'success'})
            })
        }

    };

    return <Form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="d-flex flex-wrap check_box_sec mt-0">

        <YESORNO parentClassName="col-md-4 off_yes" label="Have you lived continuously in the UK for the last 5 years" register={register} name='livedUK' />
        {
            watch("livedUK") === "no" &&
            <div className="position-relative col-12 col-md-8">
                <div className="form-group">
                    <textarea placeholder="Please provide details"  className="form-control" {...register("livedUKnotes")}></textarea>
                    <label>Please list all the countries that you have lived in over the last 5 years</label>
                </div>
            </div>
        }

        <YESORNO parentClassName="col-md-4 off_yes" label="Have you had a BCG vaccination in relation to Tuberculosis?" register={register} name='BCGvaccination' />

        <hr className="p-0 hr_row" style={{ width: "97%" }} />
        

        <div className="col-12 col-md-12">
            <h6 className="card-title" style={{ color: "rgb(121, 134, 203)" }}>Have You Had Any Of The Following?</h6>
        </div>
                
        <YESORNO parentClassName="col-md-4 off_yes" label="A cough which has lasted for more than 3 weeks" register={register} name='cough' />
        
        <YESORNO parentClassName="col-md-4 off_yes" label="Unexplained weight loss" register={register} name='weightloss' />
        
        <YESORNO parentClassName="col-md-4 off_yes" label="Unexplained fever" register={register} name='fever' />

        <YESORNO parentClassName="col-md-4 off_yes" label="Have you had tuberculosis (TB) or been in recent contact with open TB" register={register} name='TB' />
        </div>
        <NextButton />
    </Form>
}








const MedicalHistoryReport = (props = initailState) => {
    
    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , control , watch , setValue , getValues , trigger , formState , handleSubmit} = useForm({
        values:{
            heartCirculatory:props.heartCirculatory || "",
            diabetes:props.diabetes || "",
            asthma:props.asthma || "",
            bronchitis:props.bronchitis || "",
            epilepsy:props.epilepsy || "",
            headaches:props.headaches || "",
            psychiatric:props.psychiatric || "",
            dermatitis:props.dermatitis || "",
            backProblems:props.backProblems || "",
            recurrentInfections:props.recurrentInfections || "",
            hepatitis:props.hepatitis || "",
            chickenpox:props.chickenpox || "",
        },
        // resolver:yupResolver(medicalhistoryfirstSchema)
    }),
    { errors } = formState;


    

    const onFormSubmit = (data = {}) =>{
        const medical_history_report = createFormData({...data , setctionId:"medical_history_report"});
        if(updateForm ){
            updateForm(medical_history_report).then((res)=>{
                toggleAccordion("covidVaccination")
                handleSetToast && handleSetToast({id:"medical_history_2" , message:"Saved!" , type:'success'})
            })
        }

    };

    return (
        <Form onSubmit={handleSubmit(onFormSubmit)} className="how_you">
            <div className="d-flex flex-wrap check_box_sec mt-0">

                <div className="col-12 col-md-12">
                    <h6 style={{ color: "rgb(121, 134, 203)" }}>Have you ever suffered from any of the following:</h6>
                </div>

                <YESORNO parentClassName="col-md-4 off_yes" label="Heart/Circulatory Illness/Hypertension" register={register} name='heartCirculatory' />
                
                <YESORNO parentClassName="col-md-4 off_yes" label="Diabetes" register={register} name='diabetes' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Asthma/Hay fever" register={register} name='asthma' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Heart/Circulatory Illness/Hypertension" register={register} name='heartCirculatory' />
                
                <YESORNO parentClassName="col-md-4 off_yes" label="Bronchitis" register={register} name='bronchitis' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Epilepsy" register={register} name='epilepsy' />
                
                <YESORNO parentClassName="col-md-4 off_yes" label="Headaches/Migraine" register={register} name='headaches' />
                
                <YESORNO parentClassName="col-md-4 off_yes" label="Psychiatric Illness/Anxiety/Depression" register={register} name='psychiatric' />
                
                <YESORNO parentClassName="col-md-4 off_yes" label="Dermatitis/Psoriasis/Eczema" register={register} name='dermatitis' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Back problems" register={register} name='backProblems' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Recurrent infections" register={register} name='recurrentInfections' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Hepatitis/Jaundice" register={register} name='hepatitis' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Chicken pox or Shingles?" register={register} name='chickenpox' />


                {/* <div className="position-relative col-12 col-md-4 off_yes">
                    <div className="form-group">
                        <p>Heart/Circulatory Illness/Hypertension</p>
                        <ul>
                            <li><input type="radio" name="c_offence" /> Yes </li>
                            <li><input type="radio" name="c_offence" /> No </li>
                        </ul>
                    </div>
                </div> */}
                
            </div>
            <NextButton />
        </Form>
    )
}





const CovidVaccination = (props = initailState)=>{
        
    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { watch , setValue , getValues ,handleSubmit} = useForm({
        values:{    
            // COVID vaccination History
            covidVaccination:props.covidVaccination || '',
            covidVaccination_date:props.covidVaccination_date || "",},
        // resolver:yupResolver(medicalhistoryfirstSchema)
    });



    const handleOnSelect = (e , name = '') =>{
        let value = (e && e.value) || ""
        name && setValue(name ,value)
    }
    const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date)
    }

    const onFormSubmit = (data = {}) =>{
        let body = {...data}
            body.covidVaccination_date = convertToISOString(body.covidVaccination_date)
        const covidVaccination = createFormData({...body , setctionId:"covidVaccination"});
        if(updateForm){
            updateForm(covidVaccination).then((res)=>{
                toggleAccordion("immunisation_history")
                handleSetToast && handleSetToast({id:"covidVaccination" , message:"Saved!" , type:'success'})
                // toggleAccordion && toggleAccordion("contact_address_details")
            })
        }

    };


    return (
        <Form onSubmit={handleSubmit(onFormSubmit)}>

            <div className="position-relative col-12 col-md-4">
                <div className="form-group select_box">
                    <Select
                        options={VaccinationList}
                        styles={customSize}
                        isClearable={true}
                        onChange={(e) => handleOnSelect(e, "covidVaccination")}
                        value={VaccinationList.find(i => i.value === watch("covidVaccination"))}
                    />
                    <label>Are You Vaccinated?</label>
                </div>
            </div>
            {
             watch("covidVaccination") !== 'None' &&
             <DateInput parentClassName='' placeholder="Date Of Vaccination" handleOnDateChange={handleOnDateChange} name="covidVaccination_date" label="Date Of Vaccination" value={watch("covidVaccination_date")} />
            }

            <NextButton />
        </Form>
    )
}



const ImmunisationHistory = (props = initailState) =>{
       
    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register , watch , setValue , getValues , trigger , formState , handleSubmit} = useForm({
        values:{
            varicella:props.varicella || "",
            tuberculosis:props.tuberculosis || "",
            heaf:props.heaf || "",
            rubella:props.rubella || "",
            poliomyelitis:props.poliomyelitis || "",
            hepatitisB:props.hepatitisB || "",
            tetanus:props.tetanus || "",
            typhoid:props.typhoid || "",
        },
        // resolver:yupResolver(medicalhistoryfirstSchema)
    })


    const onFormSubmit = (data = {}) =>{
        const immunisation_history = createFormData({...data , setctionId:"immunisation_history"});
        if(updateForm){
            updateForm(immunisation_history).then((res)=>{
                toggleAccordion("gpdetails")
                handleSetToast && handleSetToast({id:"medical_history_2" , message:"Saved!" , type:'success'})
                // toggleAccordion && toggleAccordion("contact_address_details")
            })
        }

    };

    
    return (
        <Form onSubmit={handleSubmit(onFormSubmit)} className="how_you immun_his">
            <div className="d-flex flex-wrap check_box_sec mt-0">
                <div className="col-12 col-md-12">
                    <h6 style={{ color: "rgb(121, 134, 203)" }}>Have Had Any Of The Following Immunisations?</h6>
                </div>
                
                {/* <hr style={{ width: "97%" }} /> */}

                <YESORNO parentClassName="col-md-4 off_yes" label="Varicella" register={register} name='varicella' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Tuberculosis including BCG" register={register} name='tuberculosis' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Heaf, Mantoux or Tine" register={register} name='heaf' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Rubella (German Measles)" register={register} name='rubella' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Poliomyelitis" register={register} name='poliomyelitis' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Hepatitis B" register={register} name='hepatitisB' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Tetanus" register={register} name='tetanus' />

                <YESORNO parentClassName="col-md-4 off_yes" label="Typhoid" register={register} name='typhoid' />

                {/* <div className="position-relative col-12 col-md-4 off_yes">
                    <div className="form-group">
                        <p>Typhoid</p>
                        <ul>
                            <li><input type="radio" name="c5_offence" /> Yes </li>
                            <li><input type="radio" name="c5_offence" /> No </li>
                        </ul>
                    </div>
                </div> */}
            </div>
            <NextButton />
        </Form>
    )
}




const GPDetails = (props = initailState) =>{
       
    const { toggleAccordion = ()=>{} , handleSetToast = ()=>{} , updateForm = ()=>{} , toggleTab = ()=>{}} = props ;

    const { register  , handleSubmit , getValues , formState , setValue ,reset , watch , resetField} = useForm({
        values:{    // GP’s Details
            GPname:props.GPname || "",
            GPphone:{
                dialcountry: (props.GPphone &&  props.GPphone.dialcountry) || "",
                number: (props.GPphone &&  props.GPphone.number) || "",
                code: (props.GPphone &&  props.GPphone.code) || ""
            },
            GPstreetAddress: props.GPstreetAddress || "",
            GPcity: props.GPcity || "",
            GPstate: props.GPstate || "",
            GPzip: props.GPzip || "",
        },
        // resolver:yupResolver(medicalhistoryfirstSchema)
    })
    

    const onFormSubmit = (data = {}) =>{
        let body = {...data};
            body = body.GPphone ? {...body , ...body.GPphone} : body;
            delete body.GPphone;
        const gpdetails = createFormData({...body , setctionId:"gpdetails"});
        if(updateForm ){
            updateForm(gpdetails).then((res)=>{
                reset({} ,{keepDirty:false , keepValues:true})
                // resetField()
                handleSetToast && handleSetToast({id:"gpdetails" , message:"Saved!" , type:'success'})
                // toggleAccordion && toggleAccordion("contact_address_details")
            })
        }

    };


    const handleContinue = ()=>{
        if(formState.isDirty){
            onFormSubmit(getValues())
        }
        toggleTab("menu" ,"5")
    }



    return <Form onSubmit={handleSubmit(onFormSubmit)} className="">

        <div className="position-relative col-12 col-md-12 p-0 d-flex flex-wrap">

            <TextInput label="GP Name" placeholder='GP Name' {...register("GPname")} />

            <TextInput label="Phone No" placeholder='Phone No' {...register("GPphone.number")}/>

        </div>

        <div className="gp-add position-relative col-12 col-md-12 mt-4 pb-3">
            <h6 style={{ color: "rgb(121, 134, 203)" }}>GP Address</h6>
        </div>

        <div className="position-relative col-12 col-md-12 p-0 d-flex flex-wrap">

            <TextInput label="Street Address" placeholder='Street Address' {...register("GPstreetAddress")} />
            
            <TextInput label="City" placeholder='City' {...register("GPcity")} />
            
            <TextInput label="State / Region" placeholder='State / Region' {...register("GPstate")} />
            
            <NumberInput label="ZIP / Postal Code" placeholder='ZIP / Postal Code' {...register("GPzip")} />

        </div>

        <div className="position-relative col-12 col-md-12">

            <div className="mt-0 text-center three_button" id="s-c-buttons">
                {/* <Button onClick={()=>toggleTab("menu" ,"3")}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Previous</Button> */}
                <Button className={`${!formState.isDirty ? "cursor-no-drop" : ""} btn-save`} disabled={!formState.isDirty}    >Save</Button>
                <Button type="button" onClick={()=>handleContinue()}>Continue</Button>
            </div>

        </div>


    </Form>
}


